<template>
  <div class="content_box">
    <div class="industryCode" id="ManageTable">
      <div class="industryCode_header">
        <div class="industryCode_logo">
          <img
            style="width: 29px; height: 29px"
            src="@/assets/imgs/icon/report_view.png"
            alt
          />
        </div>
        <h3>报表查看</h3>
      </div>
      <div
        style="
          border-bottom: 1px solid rgba(155, 155, 155, 0.25);
          margin-bottom: 20px;
        "
      >
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="填报单位" style="margin-right: 30px">
            <el-input v-model="formInline.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="地区">
            <el-select v-model="formInline.region" placeholder="请选择">
              <el-option
                :key="item.code"
                :label="item.name"
                :value="item.code"
                v-for="item in seatList"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报表">
            <el-select v-model="formInline.report_cycle" placeholder="请选择">
              <el-option label="重点监测企业产值表" value="001"></el-option>
              <el-option label="重点监测企业财务表" value="002"></el-option>
              <el-option label="工业园区基本情况表" value="003"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="填报期">
            <el-date-picker
              format="yyyy-MM"
              value-format="yyyy-MM"
              v-model="formInline.date_range"
              type="month"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit"
              class="bg5584FF formBotton"
              >查询</el-button
            >
            <el-button type="info" @click="reset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table
        border
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column label="填报单位" align="center">
          <template slot-scope="scope">
            <span class="detail" @click="toDetail(scope.row)">{{
              scope.row.company_name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="报表名" align="center">
          <template slot-scope="scope">
            <span class="detail" @click="toName(scope.row)">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date_range" label="填报期" align="center">
          <template slot-scope="scope">
            <span>{{ getDateRange(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date_range" label="填报开始时间" align="center">
        </el-table-column>
        <el-table-column
          prop="date_range_end"
          label="填报结束时间"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="status" label="报表状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '3'">待审核</span>
            <span v-else-if="scope.row.status == '5'">审核未通过</span>
            <span v-else>审核通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="crt_time" label="上报时间" align="center">
          <template slot-scope="scope">
            <span
              >{{ $moment(scope.row.crt_time).format("YYYY-MM-DD HH:mm:ss") }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox">
        <!-- <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="[20, 30, 50, 100]"
          layout="sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog
        v-if="showDialogVisible"
        title="报表详情"
        :visible.sync="showDialogVisible"
        class="dialog770 titleChange"
        width="1160px"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <zdquczbShow
          v-if="editCode == '001'"
          :id="zdjcqyczbId"
          :report_yidong="report_yidong"
        ></zdquczbShow>
        <zdjcqycwbShow
          v-if="editCode == '002'"
          :id="zdjcqyczbId"
          :report_yidong="report_yidong"
        ></zdjcqycwbShow>
        <gyyqjbqkbShow
          v-if="editCode == '003'"
          :id="zdjcqyczbId"
          :report_yidong="report_yidong"
        ></gyyqjbqkbShow>
      </el-dialog>
      <el-dialog
        title="单位企业详情"
        :visible.sync="detailDialogVisible"
        :close-on-click-modal="false"
        class="dialog770 titleChange"
        width="800px"
      >
        <div class="lineTitle">
          <span>联系信息</span>
        </div>
        <el-form
          :model="showObj"
          ref="showObjForm"
          label-width="140px"
          class="demo-RuleForm"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="企业名称：">
                <el-input disabled v-model="showObj.name"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="统一社会信用代码：">
                <el-input disabled v-model="showObj.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"
              ><el-form-item label="登记注册类型：">
                <el-input
                  disabled
                  v-model="showObj.register_type"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12">
              <el-form-item label="标准行业类型：">
                <el-input disabled v-model="showObj.industry_type"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册资金（万元）：">
                <el-input disabled v-model="showObj.register_money"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册时间：">
                <el-input disabled v-model="showObj.register_time"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮编：">
                <el-input disabled v-model="showObj.post_code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否规上：">
                <el-input
                  disabled
                  :value="showObj.above_scale == '1' ? '是' : '否'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否上市：">
                <el-input
                  disabled
                  :value="showObj.listed == '1' ? '是' : '否'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否军工：">
                <el-input
                  disabled
                  :value="showObj.military == '1' ? '是' : '否'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否园区：">
                <el-input disabled v-model="showObj.dealTime"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在园区：">
                <el-input disabled v-model="showObj.district"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册区县：">
                <el-input disabled v-model="showObj.dealTime"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册地址：">
                <el-input
                  disabled
                  v-model="showObj.register_address"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="lineTitle">
          <span>联系信息</span>
        </div>

        <el-form
          :model="showObj"
          ref="showObjForm"
          label-width="135px"
          class="demo-RuleForm"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="企业邮箱：">
                <el-input
                  disabled
                  v-model="showObj.representative_person"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人代表电话：">
                <el-input
                  disabled
                  v-model="showObj.representative_phone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人电话：">
                <el-input disabled v-model="showObj.statu"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人职务：">
                <el-input
                  disabled
                  v-model="showObj.contact_position"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系手机：">
                <el-input disabled v-model="showObj.contact_phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册座机：">
                <el-input
                  disabled
                  v-model="showObj.contact_landline_phone"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <el-dialog
        title="单位园区详情"
        :visible.sync="detailYQDialogVisible"
        :close-on-click-modal="false"
        class="dialog770 titleChange"
      >
        <div class="lineTitle">
          <span>基本信息</span>
        </div>
        <el-form
          :model="showObj"
          ref="showObjForm"
          label-width="135px"
          class="demo-RuleForm"
          size="small"
        >
          <el-form-item label="园区名称：">
            <el-input disabled v-model="showObj.name"></el-input>
          </el-form-item>
          <el-form-item label="园区代码：">
            <el-input disabled v-model="showObj.code"></el-input>
          </el-form-item>
          <el-form-item label="园区类型：">
            <el-input disabled v-model="showObj.type"></el-input>
          </el-form-item>
          <el-form-item label="园区级别：">
            <el-input disabled v-model="showObj.level"></el-input>
          </el-form-item>
          <el-form-item label="园区规模：">
            <el-input disabled v-model="showObj.scale"></el-input>
          </el-form-item>
          <el-form-item label="所在区县：">
            <el-input disabled v-model="showObj.seat"></el-input>
          </el-form-item>
          <el-form-item label="园区主导产业：">
            <el-input disabled v-model="showObj.industry"></el-input>
          </el-form-item>
          <el-form-item label="园区简介：">
            <el-input disabled v-model="showObj.introduction"></el-input>
          </el-form-item>
        </el-form>
        <div class="lineTitle">
          <span>联系信息</span>
        </div>
        <el-form
          :model="showObj"
          ref="showObjForm"
          label-width="135px"
          class="demo-RuleForm"
          size="small"
        >
          <el-form-item label="联系人姓名：">
            <el-input disabled v-model="showObj.contacts"></el-input>
          </el-form-item>
          <el-form-item label="联系人职务：">
            <el-input disabled v-model="showObj.post"></el-input>
          </el-form-item>
          <el-form-item label="联系手机：">
            <el-input disabled v-model="showObj.phone"></el-input>
          </el-form-item>
          <el-form-item label="注册座机：">
            <el-input disabled v-model="showObj.landline"></el-input>
          </el-form-item>
          <el-form-item label="联系人邮箱：">
            <el-input disabled v-model="showObj.email"></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import zdjcqycwbShow from "./../../DataCollection/DataWrite/notInsert/zdjcqycwbShow/index";
import gyyqjbqkbShow from "./../../DataCollection/DataWrite/notInsert/gyyqjbqkbShow/index";
import zdquczbShow from "./../../DataCollection/DataWrite/notInsert/zdquczbShow/index";
import { mapGetters } from "vuex";
export default {
  name: "index",
  components: {
    zdjcqycwbShow,
    gyyqjbqkbShow,
    zdquczbShow,
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  data() {
    return {
      report_yidong: 0,
      tableData: [],
      currentPage: 1,
      loading: false,
      formInline: {
        name: "",
        region: "",
        report_cycle: "",
        date_range: "",
        above_scale: "",
      },
      showObj: {},
      regionTree: [],
      total: 0, //表格总数
      zdjcqyczbId: "",
      pageSize: 20,
      detailDialogVisible: false,
      detailYQDialogVisible: false,
      showDialogVisible: false,
      editCode: "",
    };
  },
  methods: {
    getDateRange(row) {
      const month = Number(row.date_range.split("-")[1]);
      const year = Number(row.date_range.split("-")[0]);
      if (row.report_cycle == 0) {
        //月报
        return row.date_range;
      } else if (row.report_cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (row.report_cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    getdata(page) {
      this.loading = true;
      this.tableData = [];
      const param = {
        page: page || 1,
        pageSize: this.pageSize,
        status: "wsh,shtg",
      };
      if (this.formInline.name !== "") {
        param["name"] = this.formInline.name;
      }
      if (this.formInline.region !== "") {
        param["region"] = this.formInline.region;
      }
      if (this.formInline.report_cycle !== "") {
        param["report_cycle"] = this.formInline.report_cycle;
      }
      if (this.formInline.date_range !== "") {
        param["date_range"] = this.formInline.date_range;
      }
      this.$axios
        .post("/business/insertMonitor/queryHandleList", param)
        .then((res) => {
          if (res.data) {
            res.data.forEach((temp) => {
              if (temp.park_name) {
                temp.company_name = temp.park_name;
                temp.company_phone = temp.park_phone;
              }
              temp.date_range_end = this.$moment(temp.date_range_end)
                .endOf("month")
                .format("YYYY-MM-DD");
            });
          }
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        });
    },
    toDetail(row) {
      const param = {
        id: row.company,
        type: row.park_name ? "park" : "company",
      };
      this.showObj = {};
      this.$axios
        .post("business/insertMonitor/getDetailInfo", param)
        .then((res) => {
          if (res.data.length) {
            this.showObj = res.data[0];
          }
          if (row.park_name) {
            this.detailYQDialogVisible = true;
          } else {
            this.detailDialogVisible = true;
          }
        });
    },
    toName(row) {
      this.editCode = row.code;
      this.zdjcqyczbId = row.id;
      this.report_yidong = row.report_yidong;
      this.showDialogVisible = true;
    },
    handleDetail(row) {
      this.detailDialogVisible = true;
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata();
    },
    reset() {
      this.formInline = {
        name: "",
        region: "",
        report_cycle: "",
        date_range: "",
        above_scale: "",
      };
      this.getdata();
    },
  },
  created() {
    this.getdata();
  },
};
</script>

<style scoped lang="less">
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}

.industryCode {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;

  .industryCode_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;

    .industryCode_logo {
      margin: 2px 20px 0 2px;
    }

    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }

  .industryCode_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;

    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }

  .industryCode_add_user {
    margin-bottom: 20px;
  }

  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>